import React, { useMemo } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdCampaign,
	MdFormatListBulleted,
	MdOutlineChecklist,
	MdOutlineComputer,
	MdOutlineLocalOffer,
	MdOutlineMonetizationOn,
} from "react-icons/md";
import { Link } from "react-router-dom";
import { BiImport, BiPhotoAlbum, BiPlusMedical } from "react-icons/bi";
import { SnippetsOutlined, StarOutlined } from "@ant-design/icons";
import { FaFireAlt } from "react-icons/fa";
import { COLORS } from "../../../../../layout/theme";

export default function ModuleMarketplace({
	userdata,
	userRol,
	activeSection,
}) {
	const generalItems = useMemo(
		() => [
			{
				to: "/admin/marketPos?uri=generalConfig",
				title: "Farmacias",
				desc: "Administración de farmacias del marketplace",
				icon: <BiPlusMedical size={16} />,
			},
			{
				to: "/admin/distributorResponse?uri=generalConfig",
				title: "Estado pedidos",
				desc: "Seguimiento del estado y respuesta de pedidos",
				icon: <SnippetsOutlined style={{ fontSize: 16 }} />,
			},
		],
		[],
	);

	const productsItems = useMemo(
		() => [
			{
				to: "/admin/marketProductsIndex?uri=generalConfig",
				title: "Productos y ofertas",
				desc: "Gestión de productos y ofertas del marketplace",
				icon: <MdOutlineChecklist size={16} />,
			},
			{
				to: "/admin/import?uri=generalConfig",
				title: "Importadores",
				desc: "Herramientas de importación masiva",
				icon: <BiImport size={16} />,
			},
		],
		[],
	);

	const publicityItems = useMemo(
		() => [
			{
				to: "/admin/advertising/campaigns?uri=generalConfig",
				title: "Campañas",
				desc: "Administración de campañas publicitarias",
				icon: <MdCampaign size={16} />,
			},
			{
				to: "/admin/marketBannersIndex?uri=generalConfig",
				title: "Banners",
				desc: "Gestión de banners publicitarios",
				icon: <BiPhotoAlbum size={16} />,
			},
			{
				to: "/admin/marketHotSalesIndex?uri=generalConfig",
				title: "Hot Sale",
				desc: "Configuración de promociones especiales",
				icon: <FaFireAlt size={16} />,
			},
			{
				to: "/admin/featuredSettings?uri=generalConfig",
				title: "Destacados",
				desc: "Configuración de productos destacados",
				icon: <StarOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/marketCoupons?uri=generalConfig",
				title: "Cupones",
				desc: "Gestión de cupones y beneficios comerciales",
				icon: <MdOutlineLocalOffer size={16} />,
			},
		],
		[],
	);

	const panel =
		activeSection === "products"
			? {
					eyebrow: "Productos",
					title: "Gestión de Productos",
					desc: "Sección para administrar productos y ofertas del marketplace",
					icon: <MdFormatListBulleted size={20} />,
					iconBg: COLORS.LightSecondary, //"#E1F5EE",
					iconColor: COLORS.Secondary, //"#0F6E56",
					items: productsItems,
				}
			: activeSection === "publicity"
				? {
						eyebrow: "Publicidad",
						title: "Publicidad del Marketplace",
						desc: "Campañas, banners, destacados y acciones comerciales",
						icon: <MdOutlineMonetizationOn size={20} />,
						iconBg: COLORS.LightDefault, //"#FAEEDA",
						iconColor: COLORS.Default, //"#854F0B",
						items: publicityItems,
					}
				: {
						eyebrow: "Configuración General",
						title: "Administración del Marketplace",
						desc: "Accesos principales para gestionar farmacias y estado de pedidos",
						icon: <MdOutlineComputer size={20} />,
						iconBg: "#E6F1FB",
						iconColor: "#185FA5",
						items: generalItems,
					};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
									{item.icon}
								</CardIconWrap>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
